/** @format */
import { Pipe, PipeTransform } from '@angular/core';
import { PersonNameService, PersonWithName } from '../service/person-name.service';

@Pipe({
    name: 'personFullName',
    standalone: false,
})
export class PersonFullNamePipe implements PipeTransform {
    constructor(private personNameService: PersonNameService) {}

    transform(person: PersonWithName): string {
        return person && this.personNameService.getFullName(person);
    }
}
